/**
 * Handles HTML line breaks in tooltip content.
 * Due to content being entered through external systems/forms where users often input <br/> tags,
 * we need to convert these HTML breaks to actual line breaks.
 *
 * @param text - The tooltip content that may contain <br>, </br>, or <br/> tags
 * @returns string with HTML break tags replaced with newline characters
 */
export const formatTooltipText = (text: string | undefined) => {
  return text?.replace(/<\/?br\s*\/?>/g, '\n');
};
